import { PdfTemplateEditor } from "@/components/pdf-template/pdf-template-editor";

export default function QuoteDocumentDesignPage() {
  return (
    <div className="flex h-[calc(100dvh-4rem)] min-h-[32rem] flex-col overflow-hidden" data-testid="page-quote-document-design">
      <PdfTemplateEditor />
    </div>
  );
}
